import { TRIGGER_TYPES } from '../../blocks/trigger';
import { HomeLoansDashboardViewEvent } from '../registeredEvents';
import { HomeLoansDashboardClickstreamEvent } from './HomeLoansDashboardClickstreamEvent';
import { HomeLoansDashboardBaseEventProps, getHomeLoansDashboardEvent } from './getHomeLoansDashboardEvent';
export type HomeLoansDashboardViewEventProps = {
    event: HomeLoansDashboardViewEvent;
} & HomeLoansDashboardBaseEventProps;

export const getHomeLoansDashboardViewEvent = ({
    event,
    lead_id,
    journey_stage_cd,
    variant_nm,
}: HomeLoansDashboardViewEventProps): HomeLoansDashboardClickstreamEvent =>
    getHomeLoansDashboardEvent({
        event,
        lead_id,
        journey_stage_cd,
        variant_nm,
        trigger_type_nm: TRIGGER_TYPES.VIEW,
    });
